type Props = {
  width?: string | number;
  height?: string | number;
  strokeColor?: string;
};

/**
 * Two arrows pointing in from opposite corners: "back to the normal size".
 * Pairs with `MaximizeIcon`; same 12×12 stroke style as `CloseIcon`.
 */
const MinimizeIcon = (props: Props) => {
  const { width = 12, height = 12, strokeColor = 'currentColor' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M11 4.5H7.5V1M7.5 4.5 11 1M1 7.5h3.5V11M4.5 7.5 1 11"
        stroke={strokeColor}
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MinimizeIcon;
